import type { ReportedHourViewModel } from "../../../hour-reports/api"
import { HourReportDayAuditViewModel } from "../../../hour-reports/api/hour-report-day-audit"
import { makeTreeGridApprovedHourDateGroup } from "./date-group-row"
import { makeTreeGridApprovedHourRow, ApprovedHourRowTranslations } from "./hour-report-row"
import type { ApprovedHourDateGroupTranslations } from "./date-group-row"
import { TreeGridApprovedHour, TreeGridApprovedHourDateGroup } from "./types"
import { makeDateKey, makeDateRange } from "./utils"

export const makeTreeGridApprovedHourRows = ({
  dateFormat,
  fromDate,
  toDate,
  reports,
  dayAudits,
  selectedMemberForDayAudit,
  enableAddingReports,
  translations,
}: MakeRowsProps): TreeGridApprovedHourDateGroup[] => {
  const reportsByDate = new Map<string, TreeGridApprovedHour[]>()
  const auditsByDate = new Map<string, HourReportDayAuditViewModel>()

  reports.forEach((report) => {
    const reportDateKey = makeDateKey(new Date(report.date))
    const dateReports = reportsByDate.get(reportDateKey) || []
    dateReports.push(makeTreeGridApprovedHourRow({ report, dateFormat, translations }))
    reportsByDate.set(reportDateKey, dateReports)
  })

  dayAudits.forEach((audit) => {
    auditsByDate.set(audit.date, audit)
  })

  return makeDateRange(fromDate, toDate).map((date) => {
    const dateKey = makeDateKey(date)
    return makeTreeGridApprovedHourDateGroup({
      date,
      dateFormat,
      reports: reportsByDate.get(dateKey) || [],
      dayAudit: auditsByDate.get(dateKey),
      selectedMemberForDayAudit,
      enableAddingReports,
      translations,
    })
  })
}

export type {
  TreeGridApprovedHour,
  TreeGridApprovedHourDateGroup,
  TreeGridApprovedHourDateGroupRow,
  TreeGridApprovedHourRow,
} from "./types"

type MakeRowsProps = {
  reports: ReportedHourViewModel[]
  dayAudits: HourReportDayAuditViewModel[]
  selectedMemberForDayAudit: string | undefined
  enableAddingReports?: boolean
  dateFormat: string
  fromDate: Date
  toDate: Date
  translations: ApprovedHourRowTranslations & ApprovedHourDateGroupTranslations
}
